{
  "enum": {
    "IxtBuildsV1RepoStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxtBuildsV1RepoQueryServiceRepoListFilterableFields": {
      "name": "Name",
      "owner": "Owner",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxtBuildsV1Action": {
      "j5Build": "J5 Build",
      "o5Build": "O5 Build"
    },
    "IxtBuildsV1Condition": {
      "branch": "Branch",
      "tag": "Tag"
    },
    "IxtBuildsV1RepoEventType": {
      "configure": "Configure"
    }
  },
  "sortEnum": {
    "IxtBuildsV1RepoQueryServiceRepoListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}